import { render, staticRenderFns } from "./addressListSimple.vue?vue&type=template&id=5c659512&scoped=true&"
import script from "./addressListSimple.vue?vue&type=script&lang=js&"
export * from "./addressListSimple.vue?vue&type=script&lang=js&"
import style0 from "./addressListSimple.vue?vue&type=style&index=0&id=5c659512&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c659512",
  null
  
)

export default component.exports